import { jsx as o, jsxs as E } from "@emotion/react/jsx-runtime";
import { useState as j, useRef as w, useEffect as z } from "react";
import { useTheme as W } from "@emotion/react";
import { StyledLink as q, StyledChildren as v, StyledExternalIconContainer as B } from "./Link.styled.js";
import { recursivelyGetChildrenString as G } from "../../utils/recursivelyGetChildrenString.js";
import { Icon as M } from "../Icon/index.js";
import { Tooltip as _ } from "../Tooltip/index.js";
const O = ({
  children: t,
  href: a,
  target: n,
  hideExternalIcon: f = !1,
  download: d,
  variant: l = "secondary",
  textVariant: s = "bodyMSemibold",
  disabled: m = !1,
  rel: u,
  className: p,
  "aria-label": h,
  oneLine: e = !1,
  "data-track": S,
  ref: c
}) => {
  const y = W(), i = n === "_blank", k = !f && i, b = u || (i ? "noopener noreferrer" : void 0), [x, C] = j(!1), I = w(null), r = c ?? I, R = G(t);
  return z(() => {
    if (e && r?.current) {
      const {
        offsetWidth: T,
        scrollWidth: g
      } = r.current;
      C(T < g);
    }
  }, [e, c, r]), /* @__PURE__ */ o(_, { text: e && x ? R : "", children: /* @__PURE__ */ E(q, { href: a, target: n, download: d, ref: r, variant: l, textVariant: s, rel: b, className: p, disabled: m, "aria-label": h, oneLine: e, "data-track": S, children: [
    /* @__PURE__ */ o(v, { children: t }),
    k ? /* @__PURE__ */ o(B, { children: /* @__PURE__ */ o(M, { icon: ["fa-arrow-up-right-from-square"], color: l, iconSize: y.typography[s].fontSize }) }) : null
  ] }) });
};
export {
  O as Link
};
